import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[phx-list-action]',
  host: { class: 'phx-list-action' },
})
export class PhxListItemActionDirective {
  @HostBinding('attr.tabindex') tabIndex = -1;

  @HostListener('click', ['$event']) onClick(event){
    event.stopPropagation();
  }
}
